/* eslint-disable @typescript-eslint/no-empty-function */
/*eslint-disable @typescript-eslint/restrict-template-expressions*/
import React from "react";

import Select_ from "react-select";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import colors from "../../../../utils/colors";
import { withField as withFieldWrapper } from "../Field";

const Container = styled.div`
    position: relative;
    margin-top: 5px;
    margin-bottom: 5px;
`;

const Select = styled(Select_)`
    font-size: 1em;
    padding: 5px 10px 5px 0;
    line-height: 20px;
    border-radius: 4px;
    border-width: 1px;
    border-color: ${colors.darkGrey};
    color: ${colors.blue};
    border-style: solid;
    max-width: 100%;
    background-color: white;
    width: 100%;
    appearance: none;

    ${({ isDisabled }) => css`
        background: ${isDisabled ? "#dbdbdb" : "white"};
    `}

    &:focus ~ span {
        align-items: flex-start;
        font-size: 0.75em;
    }

    &:not(:placeholder-shown) ~ span {
        align-items: flex-start;
        font-size: 0.75em;
    }

    &:focus-within {
        cursor: pointer;
        outline: 1px solid blue;
    }
`;

const Placeholder = styled.span`
    position: absolute;
    top: 2px;
    left: 11px;
    display: flex;
    align-items: center;
    height: 100%;
    overflow: visible !important;
    font-size: 1rem;
    color: ${colors.darkGrey};
    pointer-events: none;
    transition: 0.2s ease all;
`;

const NewSelectInput = ({
    options,
    name,
    id = null,
    placeholder = "Bitte wählen",
    fullwidth = false,
    withField = false,
    minWidth,
    isDisabled = false,
    className,
    ...props
}) => {
    const theme = useTheme();
    const colourStyles = {
        control: (styles, state) => ({
            ...styles,
            minHeight: "28px",
            maxHeight: "32px",
            fontSize: "0.75em",
            fontWeight: "400",
            borderColor: state.isFocused ? "#79797a" : "black",
            border: "1px solid #0000",
            // This is an example: backgroundColor: isDisabled ? "rgba(206, 217, 224, 0.5)" : "white"
            backgroundColor: state.isDisabled ? "#dbdbdb" : "white",
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none",
            },
        }),
        valueContainer: (styles) => ({
            ...styles,
            fontSize: "0.75em",
            fontWeight: "400",
            paddingLeft: "calc(0.75em - 1px)",
            paddingRight: "calc(0.75em - 1px)",
            paddingTop: "0px",
            paddingBottom: "0px",
            width: "150px",
            minHeight: "28px",
            maxHeight: "32px",
        }),
        singleValue: (styles) => ({
            ...styles,
            color: colors.blue,
            fontSize: "1.25em",
            paddingTop: "9px",
            fontWeight: "400",
        }),
        indicatorSeparator: (styles) => ({
            ...styles,
            display: "none",
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            fontSize: "0.75em",
            fontWeight: "400",
            padding: "4px",
            minHeight: "28px",
            maxHeight: "32px",
        }),
        input: (styles) => {
            return {
                ...styles,
                color: colors.blue,
                fontSize: "1.25em",
                fontWeight: "400",
                margin: "0px",
                paddingBottom: "0px",
                paddingTop: "9px",
                minHeight: "28px",
                maxHeight: "32px",
            };
        },
        menu: (styles) => ({
            ...styles,
            zIndex: "999",
            fontSize: "1em",
        }),
        option: (styles, { isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                fontWeight: "400",
                fontSize: "0.75em",
                // textAlign: "center",
                color: "black",
                cursor: isDisabled ? "not-allowed" : "default",
                backgroundColor: isSelected
                    ? "#f8f5f2"
                    : isFocused
                    ? "#ebebeb"
                    : "#ffffff",
            };
        },
        placeholder: (styles) => ({
            ...styles,
            width: "100%",
            textAlign: "center",
            fontSize: "1.25em",
        }),
    };
    const component = (
        <Container
            css={css`
                ${fullwidth ? "width: 100%;" : ""}
            `}
            {...{ className }}
        >
            <Select
                id={id ?? name}
                {...{ name, options }}
                errorClassName="is-light"
                isDisabled={
                    !(Array.isArray(options) && options.length > 0) ||
                    isDisabled
                }
                styles={colourStyles}
                theme={(theme) => {
                    return {
                        ...theme,
                        borderRadius: "6px",
                        colors: {
                            ...theme.colors,
                            text: "black",
                        },
                    };
                }}
                css={css`
                    ${fullwidth ? "width: 100%;" : ""}
                    ${minWidth ? `min-width: ${minWidth};` : ""}
                    ${theme.breakpoints.from.medium.css`font-size: 1.25em;`}
                `}
                {...props}
            />
            <Placeholder>{placeholder}</Placeholder>
        </Container>
    );

    return withField ? withFieldWrapper(component) : component;
};

export default NewSelectInput;
